import { Button, Typography } from '@mui/material'
import axios from 'axios'
import { useState } from 'react'

export default function LoadCatalog() {
  const [file, setFile] = useState<File | null>(null)

  const handleLoadCatalog = () => {
    if (!file) return
    const formData = new FormData()
    formData.append('file', file)

    axios.post(`/admin/loadCatalog`, formData).catch(err => {
      console.error(err.response.data)
    })
  }

  return (
    <div>
      <Button variant="contained" component="label">
        Select File
        <input type="file" onChange={e => setFile(e.target.files?.[0] ?? null)} />
      </Button>
      <Button variant="contained" onClick={handleLoadCatalog} disabled={!file}>
        Load Catalog
      </Button>
      {file && <Typography>{file.name}</Typography>}
    </div>
  )
}
